import { css } from '@emotion/react'
import { type Styles } from 'react-select'
import { fontSize, fontWeight, colors } from '@retailer-platform/shared-components'

export const accountManagementWrapperStyles = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
})

export const idsSelectStyles: Styles = {
  control: (styles, state) => ({
    boxShadow: state.isFocused
      ? `0 0 0 2px ${colors.GRAYSCALE.X70}`
      : `0 0 0 1px ${colors.GRAYSCALE.X30}`,
    border: 'none',
    minHeight: '38px',
    fontSize: fontSize.X15,
    fontWeight: fontWeight.REGULAR,
    lineHeight: '22px',
    transition: 'box-shadow 200ms ease-in-out',
    ':hover': {
      outline: 'none',
      boxShadow: state.isFocused
        ? `0 0 0 2px ${colors.GRAYSCALE.X70}`
        : `0 0 0 1px ${colors.GRAYSCALE.X70}`,
    },
  }),
}
